import { render, staticRenderFns } from "./ModalCadastroHospitais.vue?vue&type=template&id=18dfe3d5&scoped=true"
import script from "./ModalCadastroHospitais.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroHospitais.vue?vue&type=script&lang=ts"
import style0 from "./ModalCadastroHospitais.vue?vue&type=style&index=0&id=18dfe3d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfe3d5",
  null
  
)

export default component.exports